import NavigationBar from '../components/Navigation/NavigationBar';
import PageWithContent from '../components/PageWithContent';
import noAccessLock from '../images/no-access.svg';
import { noAccessLogoContainerCSS, noAccessTextContainerCSS } from './styles/NoAccessPage.styles';

export default function Component() {
    const lockTitle = 'RevStats';
    const lockIcon = noAccessLock;
    return (
        <>
            <NavigationBar />
            <PageWithContent>
                <div css={noAccessLogoContainerCSS}>
                    <img alt={lockTitle} src={lockIcon} />
                </div>
                <div css={noAccessTextContainerCSS}>
                    Sorry, you don&apos;t have permission to access this page
                </div>
            </PageWithContent>
        </>
    );
}

Component.displayName = 'NoAccessPage';
